import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const WindowPageLazy = loadable(() => import(/* webpackChunkName: "Windows" */ './WindowPageSuspense'));

export const WindowPageAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <WindowPageLazy />
    </DelayedSuspense>
);
